import { formatNumber } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { SchoolViewModel } from 'src/app/models/school/schooladminitem.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { PaymentService } from 'src/app/services/payment.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';

declare const $: any;

@Component({
  selector: 'app-progress-card',
  templateUrl: './progress-card.component.html',
  styleUrls: ['./progress-card.component.css']
})
export class ProgressCardComponent implements OnInit {
  @Input() module: any;
  @Input() hasMenu: boolean;
  @Input() url: string;
  @Input() queryParam: string;
  selectedBatchId: number = 0;
  //@Input() livemeetinglink: string;
  //@Input() hasliveclass: string;
  @Input() type: string = 'course';
  @Input() inPackage: boolean = false;
  @Input() currentUserIsAdmin: boolean = false;
  @Output() deleteClicked: EventEmitter<any> = new EventEmitter<any>();
  typeString: string = '';
  //contentTypeString: string = '';
  moduleDetails: any;
  moduleBatches: SchoolModuleBatch[] = [];
  modaltargetId: string;
  modalId: string;
  paymentWindow: Window;
  //school: SchoolInformationview
  school: SchoolViewModel = new SchoolViewModel();

  constructor(@Inject(LOCALE_ID) public locale: string, 
  public headerService: ComponentheaderService, 
  private util: UtilService,
  public useraccessservice: UseraccessserviceService,
  private moduleService: ModulemanagementService,
  private toastr: ToastrService,
  private payments: PaymentService,
  private route: Router
) { 
  }

  get contentTypeString(): string{
    switch(this.type){
      case 'course':
        return this.module.lessonCount == 1 ? 'lesson' : 'lessons';
      case 'package':
        return this.module.courseCount == 1 ? 'course' : 'courses';
      default:
        this.typeString = '';
    }
  }

  async ngOnInit(): Promise<void> {
    if(this.module.courseTitle)
      this.moduleDetails = await this.moduleService.getModuleDetails(this.module.id).toPromise();

    this.school = this.util.schoolInfoBundle.schoolInfo;
    this.modalId = `modal_${this.module.id}`;
    this.modaltargetId = `#${this.modalId}`;

    switch(this.type){
      case 'course':
        this.typeString = 'course';
        //this.contentTypeString = 'Lessons';
        //debugger;
        break;
      case 'package':
        this.typeString = 'package';
        //this.contentTypeString = 'Courses';
        break;
      default:
        this.typeString = '';
    }
  }

  get title(): string{
    switch(this.type){
      case 'course':
        return this.module.courseTitle;
        break;
      case 'package':
        return this.module.name;
        break;
      default:
        return '';
    }
  }

  get contentCount(): number{
    switch(this.type){
      case 'course':
        return this.module.lessonCount;
        break;
      case 'package':
        return this.module.courseCount;
        break;
      default:
        return 0;
    }
  }

  get price(): number {
    switch (this.type) {
      case 'course':
        return this.module.price;
        break;
      case 'package':
        return this.module.amountPerStudent;
        break;
      default:
        return 0;
    }
  }

  get accessDays(): number {
    switch (this.type) {
      case 'course':
        return this.module.accessDays;
        break;
      case 'package':
        return this.module.accessdays;
        break;
      default:
        return 0;
    }
  }

  deleteButtonClicked(){
    this.deleteClicked.emit(this.module);
  }

  formatNumber(_number: number){
    return formatNumber(_number, this.locale);
  }
  
  async popBatches() {
    this.moduleBatches = await this.moduleService
      .getEnrollmentModuleBatches(this.module.id)
      .toPromise();
    $('#popbatch').modal('show');
  }

  async submitEnroll() {
    if (this.moduleDetails?.allowBatches)
      await this.popBatches();
    else
      await this.enroll();    
  }
  async enroll() {
    await this.moduleService.enroll(this.moduleDetails?.allowBatches, this.selectedBatchId, this.module.price, this.payments,
      this.toastr, this.module.id, this.paymentWindow);

    if (this.module.price <= 0) {
      this.gotoCourse();
    }
    $('#popbatch').modal('hide');
  }  

  gotoCourse(){
    this.route.navigate(
      ['user/moduledetails'],
      {
        queryParams: { moduleID: this.module.id }
      }
    );
  }
}
